module.exports = __webpack_public_path__ + "static/media/i_webcam.f0e59ad5.svg";